import { useCallback } from "react";
import { useDispatch } from "react-redux";

import {
  endLoadingProcess,
  startLoadingProcess,
} from "../store/actions/loader";

const useLoader = () => {
  const dispatch = useDispatch();

  const showLoader = useCallback((id) => dispatch(startLoadingProcess(id)), [
    dispatch,
  ]);

  const hideLoader = useCallback((id) => dispatch(endLoadingProcess(id)), [
    dispatch,
  ]);

  return [showLoader, hideLoader];
};

export default useLoader;
